module.exports = __webpack_public_path__ + "static/media/logo-nexxus-negativo.0efda67e.svg";